module.exports = __webpack_public_path__ + "static/media/phone-call.7dc6edbe.png";